
type PaginatorProps = {
    prev_page: number;
    next_page: number;
    page: number;
    pages: number[];
    navigate: (page: number, rows?: string) => void;
    rows: number
}
// TODO: work this paginator for this application 


const Paginator = ({ prev_page, next_page, page, pages, navigate, rows }: PaginatorProps) => {

    const get_rows = () => {
        const ele = document.getElementById("rows") as HTMLSelectElement
        return ele.value
    }


    return (
        <nav aria-label="..." className={'d-flex flex-row justify-content-between mt-4'}>

            <ul className="pagination pagination-sm">
                <li className={prev_page < 1 ? "page-item disabled" : "page-item"}>
                    <button className="page-link" onClick={() => navigate(prev_page, get_rows())}
                        disabled={prev_page < 1}>
                        Previous
                    </button>
                </li>
                <li className="page-item">
                    <button className="page-link" onClick={() => navigate(next_page, get_rows())}
                        disabled={next_page < 1}>
                        Next
                    </button>
                </li>
            </ul>

            <div className={'right'} style={{ width: '500px' }}>

                <ul className='pagination pagination-sm d-flex flex-row justify-content-between'>
                    <li className={'d-flex flex-row mg-left'}>
                        <label>Page:</label>  &nbsp;
                        <input className={'form-control form-control-sm'}
                            type="number" placeholder="page no?"
                            value={page}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) : 0
                                navigate(page, get_rows())
                            }}
                            style={{ width: '50px' }}
                        />
                    </li>
                    <li className={'d-flex flex-row mg-left'}>
                        <label> Total Pages :  {pages.length} </label>
                    </li>
                    <li className={'d-flex flex-row mg-left'}>
                        <label>records:</label>  &nbsp;
                        <select defaultValue={rows} id="rows"
                            onChange={(e) => navigate(page, e.target.value)}
                            className='form-control form-control-sm'>
                            <option value={10}> 10 </option>
                            <option value={15}> 15 </option>
                            <option value={50}> 50 </option>
                            <option value={100}> 100 </option>
                            <option value={200}> 200 </option>
                            <option value={500}> 500 </option>
                        </select>
                    </li>

                </ul>
            </div>
        </nav>
    )
}

export default Paginator 